"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pcaWorldOptions = exports.pcaUkOptions = exports.loqateEmailVerificationKey = exports.loqateEmailVerificationApi = exports.getStripePublishableKey = exports.getSampleIdValidateUrl = exports.getSampleIdPostUrl = exports.getGoogleReCaptchaKey = exports.getApiBaseUrl = exports.configure = void 0;

var _novaFrontendRestClient = require("@an/nova-frontend-rest-client");

var _flowRuntime = _interopRequireDefault(require("flow-runtime"));

var AuthModule = _flowRuntime["default"].tdz(function () {
  return _novaFrontendRestClient.AuthModule;
});

var apiBaseUrl = 'http://dev-nova-website-api.azurewebsites.net/api';

var getApiBaseUrl = function getApiBaseUrl() {
  return apiBaseUrl;
};

exports.getApiBaseUrl = getApiBaseUrl;
var stripePublishableKey;

var getStripePublishableKey = function getStripePublishableKey() {
  return stripePublishableKey;
};

exports.getStripePublishableKey = getStripePublishableKey;
var googleReCaptchaKey = '6LelIxQiAAAAABo0EcFBFiqIV-Cdw2tYPslUmPJn';

var getGoogleReCaptchaKey = function getGoogleReCaptchaKey() {
  return googleReCaptchaKey;
}; // Power Automate Flow
// Name: Website - Event Donor Applications - Check Whether Sample ID Has Been Used
// Link: https://make.powerautomate.com/environments/b989a7c6-1d63-40ff-aa13-124856fa98ab/solutions/763ef8d1-80f4-ed11-8849-6045bd0e6819/flows/6c107ccd-3ff3-40bd-a4f5-144374506a50/details


exports.getGoogleReCaptchaKey = getGoogleReCaptchaKey;
var sampleIdValidateUrl = 'https://prod-22.uksouth.logic.azure.com/workflows/275250cabfe14152a4697d041ba7528e/triggers/manual/paths/invoke/sampleId/{sampleId}?api-version=2016-06-01&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=lwLpRSXXS8fvdnDoAiJyreq8uCyjPxU_YjaUi2Wl_GA';

var getSampleIdValidateUrl = function getSampleIdValidateUrl() {
  return sampleIdValidateUrl;
}; // Power Automate Flow
// Name: Website - Event Donor Applications - Add Sample ID to Table
// Link: https://make.powerautomate.com/environments/b989a7c6-1d63-40ff-aa13-124856fa98ab/solutions/763ef8d1-80f4-ed11-8849-6045bd0e6819/flows/e0e1e7f9-ca90-4015-af7e-e065b05da7df/details


exports.getSampleIdValidateUrl = getSampleIdValidateUrl;
var sampleIdPostUrl = 'https://prod-31.uksouth.logic.azure.com/workflows/d4acd0c54d4f4398b25b42318a461e30/triggers/manual/paths/invoke?api-version=2016-06-01&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=6aA3xOFkup19NYLch4NC769qbNxykS3R5ixo28sTyu0';

var getSampleIdPostUrl = function getSampleIdPostUrl() {
  return sampleIdPostUrl;
};

exports.getSampleIdPostUrl = getSampleIdPostUrl;

var configure = function configure(formsBaseUrl, formsStripePublishableKey, formsGoogleReCaptchaKey, formsSampleIdValidateUrl, formsSampleIdPostUrl, authModule) {
  apiBaseUrl = formsBaseUrl;
  stripePublishableKey = formsStripePublishableKey;
  googleReCaptchaKey = formsGoogleReCaptchaKey;
  sampleIdValidateUrl = formsSampleIdValidateUrl;
  sampleIdPostUrl = formsSampleIdPostUrl;

  if (authModule) {
    (0, _novaFrontendRestClient.setAuthenticationModule)(authModule);
  }
};

exports.configure = configure;
var loqateEmailVerificationApi = 'https://api.addressy.com/EmailValidation/Interactive/Validate/v2.00/json3.ws';
exports.loqateEmailVerificationApi = loqateEmailVerificationApi;
var loqateEmailVerificationKey = 'AA43-ZE96-GX17-EZ49';
exports.loqateEmailVerificationKey = loqateEmailVerificationKey;
var loqateAddressVerificationKey = 'WB95-BU89-DC51-ME62';
var pcaWorldOptions = {
  key: loqateAddressVerificationKey,
  setCountryByIP: true,
  suppressAutocomplete: false
};
exports.pcaWorldOptions = pcaWorldOptions;
var pcaUkOptions = {
  key: loqateAddressVerificationKey,
  countries: {
    codesList: 'GBR'
  },
  setCountryByIP: true,
  suppressAutocomplete: false
};
exports.pcaUkOptions = pcaUkOptions;